module.exports = __webpack_public_path__ + "static/media/sort-size-down-alt.01021c0a.svg";